<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{

    }
  },
  mounted(){
    this.$router.afterEach((to,from) => {
      console.log(to)
      document.title = this.$i18n.messages[this.$i18n.locale].title[to.name+'Title']
    })
  }
}
</script>

<style lang="scss">
div,span,ul,li,a,p{
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: '微软雅黑';
}
.pc div,span,ul,li,a,p{
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-size: 16px;
}
a {
  text-decoration: none;
  color: #000;
}
li {
  list-style: none;
}
body{
  padding: 0;
  margin: 0;
  font-size: .32rem;
  #app{
    height: 100vh;
    width: 100vw;
  }
}
// #app {
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   margin-top: 60px;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue